import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, Styles } from "jspdf-autotable";

import { DriverContact } from "../../drivers.types";
import { getContacts } from "./getContacts";

interface renderContactsProps {
  pdf: jsPDF;
  normalFontStyles: Partial<Styles>;
  driverContacts: DriverContact[];
}

export const renderContacts = ({
  pdf,
  normalFontStyles,
  driverContacts
}: renderContactsProps) => {
  const { contacts } = getContacts({
    driverContacts,
    normalFontStyles
  });

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY ?? 80,
    styles: { cellPadding: 3, lineWidth: 1, lineColor: "#000000" },
    head: [
      [
        {
          content: "CONTACT",
          styles: {
            valign: "middle",
            halign: "left",
            ...normalFontStyles
          }
        },
        {
          content: "PHONE NUMBERS",
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles
          }
        },
        {
          content: "EMAILS",
          styles: {
            valign: "middle",
            halign: "right",
            ...normalFontStyles
          }
        }
      ]
    ],
    body: contacts,
    tableLineWidth: 1,
    tableLineColor: "#000000"
  });
};
